import {atom} from "recoil";
import {persistAtomEffect} from "../effects/persistAtom";
export const walletCardSubsState = atom({
  key: 'WalletCardSubsState',
  default: null,
  effects: []
});
